import { render } from "./examList.vue?vue&type=template&id=ab2ab642&scoped=true&ts=true"
import script from "./examList.vue?vue&type=script&lang=ts"
export * from "./examList.vue?vue&type=script&lang=ts"

import "./examList.vue?vue&type=style&index=0&id=ab2ab642&scoped=true&lang=scss"

import exportComponent from "D:\\ct-construction-ts-mobile\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab2ab642"]])

export default __exports__